import * as yup from "yup";

export const WorkOrderValidationSchema = yup.object().shape({
    requisition: yup
        .object()
        .shape({
            id: yup.number().required("Requisition is Required"),
            label: yup.string(),
            name: yup.string(),
        })
        .typeError("Please select Requisition"),
    order_date: yup.date().required("Order date is Required").nullable(),
    payment_date: yup.date().required("Payment date is Required").nullable(),
    remark: yup.string().max(100, "Remark not more than 100 characters."),
    order_items: yup.array().of(
        yup.object().shape({
            brand: yup.object().shape({
                id: yup.number().required("Brand is Required"),
                name: yup.string(),
                label: yup.string(),
            })
            .typeError("Please select brand"),
            unit_price: yup.number().required("Unit price is Required"),
        })
    ),
});
